<template lang="html">
    <div class="page-title mt-3 mb-4 d-flex align-items-center">
        <div class="mr-auto">
            <h4 class="weight500 d-inline-block pr-3 mr-3 border-right">{{crumbs[crumbs.length - 1].split('_').join(' ')}}</h4>
            <nav aria-label="breadcrumb" class="d-inline-block ">
                <ol class="breadcrumb p-0">
                    <li class="breadcrumb-item">Admin</li>
                    <li class="breadcrumb-item" v-for="c in crumbs">
                        <router-link :to="{name: c}" class="link" v-if="c !== crumbs[crumbs.length - 1]">
                            {{c.split('_').join(' ')}}
                        </router-link>
                        <span class="active-link" v-else="c === crumbs[crumbs.length - 1]">{{c.split('_').join(' ')}}</span>
                    </li>
                </ol>
            </nav>
        </div>
        <div class="actions" v-show="actions.length > 0">
            <Dropdown 
               class="dropdown fx-dropdown"
               trigger="click"
               placement="bottom-end"
            >
                <button class="btn btn-primary btn-transparent btn-round" title="Configs">
                   <i class="fa fa-sliders-h"></i>
                   Actions
                </button>

               <DropdownMenu slot="list" class="profile">
                  <div class="profile-details">
                     <div class="flex-center">
                        <div class="btn-transparent btn-primary btn-drop"><i class="fa fa-sliders-h"></i></div>
                     </div>
                     <div class="prof-title">{{title}}</div>
                     <div class="subtitle">{{desc}}</div>
                  </div>

                  <DropdownItem 
                     v-for="action in actions" 
                     :key="action.event"
                  >
                     <div class="action clearfix" @click="triggerEvent(action.event,action.payload)">
                        <i class="fa" :class="action.icon || 'fa-eye'"></i> 
                        <div class="title">{{action.title}}</div>
                     </div>
                  </DropdownItem>
               </DropdownMenu>
            </Dropdown>
         
            <!-- <div class="dropdown fx-dropdown">
                <div class="fx-nav-item dropdown-toggle no-arrow" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div class="btn btn-primary btn-transparent btn-round" title="Configs"><i class="fa fa-sliders-h"></i></div>
                </div>
                <div class="dropdown-menu profile" aria-labelledby="dropdownMenuButton">
                    <div class="profile-details">
							  <div class="flex-center">
                        <div class="btn-transparent btn-primary"><i class="fa fa-sliders-h"></i></div>
							  </div>
								<div class="prof-title">{{title}}</div>
                        <div class="subtitle">{{desc}}</div>
                    </div>

                    <div class="action clearfix" v-for="action in actions" @click="triggerEvent(action.event,action.payload)">
                        <div class="fa" :class="action.icon"></div>
                        <div class="title">{{action.title}}</div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
   components:{
      Dropdown: () => import("@/libs/clarks/components/dropdown/dropdown"),
      DropdownItem: () => import("@/libs/clarks/components/dropdown/dropdown-item"),
      DropdownMenu: () => import("@/libs/clarks/components/dropdown/dropdown-menu"),
   },
	created(){
		let $this = this

		EventBus.$on('page:loading',(isLoading) => {
            // if(isLoading){
            //     $this.actions = []
            // }
		})

		EventBus.$on('actions:register',(payload) => {
			if(payload.actions.length > 0){
				$this.title = payload.title
				$this.actions = payload.actions
			}
		})
	},
	mounted() {
		this.crumbs = this.$route.name.split("-");
	},
	watch: {
		$route: function(to, from) {
			this.crumbs = to.name.split("-");
		}
	},
	methods: {
		triggerEvent (event,payload) {
			EventBus.$emit(event,payload)
		},
	},
	data() {
		return {
			crumbs: ["Dashboard"],
			actions: [],
			title: 'Lorem Actions',
			desc: 'Actions available on a page.',
		};
	}
};
</script>

<style lang="scss">
.page-title {
	.active-link {
		font-weight: 600;
	}

    .flex-center{
        display: flex;
        justify-content: center;

        .btn-transparent.btn-drop{
            width: 35px !important;
            height: 35px !important;
            text-align: center;
            padding: 5px 0 !important;
            font-size: 18px;
            border-radius: 4px;
        }
    }
	.actions {
		float: right;
		margin: -20px 25px 0 0;

		.btn-transparent {
			padding: 8px 15px !important;
			font-size: 15px;
		}
	}
}
</style>